module.exports = __webpack_public_path__ + "img/gradient.4c7a46c6.jpg";